import { Segmented } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllConditionsListSlice } from 'src/modules/SuperAdmin/store/slices';
import ServiceRequestTypeMappingPage from './ServiceRequestTypeMapping/ServiceRequestTypeMapping.page';
import ColumnMappingPage from './ColumnMapping/ColumnMapping.page';
import ProviderMappingPage from './ProviderMapping/ProviderMapping.page';
import { getFromStorage, storeInLocal } from '../../../../../lib/storage';
import OrganizationFilter from '../SuperAdmin/OrganizationFilter';
import ServiceRequestStatusMappingPage from './ServiceRequestStatusMapping/ServiceRequestStatusMapping.page';
import { usePageHeader } from 'src/hooks/misc';
import { ServiceRequestTypes } from 'src/pages/superAdmin/serviceRequest';
import { SuperAdminScope } from 'src/components';

const ServiceRequestUpload = () => {
  const superAdminButton = [
    {
      label: 'Column mapping',
      value: 'columnMapping',
      component: <ColumnMappingPage />,
    },
    {
      label: 'Provider mapping',
      value: 'providerMapping',
      component: <ProviderMappingPage />,
    },
    {
      label: 'Types',
      value: 'types',
      component: (
        <SuperAdminScope>
          <ServiceRequestTypes />
        </SuperAdminScope>
      ),
    },
    {
      label: 'Types mapping',
      value: 'typesMapping',
      component: <ServiceRequestTypeMappingPage />,
    },
    {
      label: 'Status mapping',
      value: 'statusMapping',
      component: <ServiceRequestStatusMappingPage />,
    },
  ];

  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('srUploadSegment') || superAdminButton[0].value;
  });

  const dispatch = useDispatch();

  usePageHeader({
    title: 'CSV Upload: Service Request',
  });

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    dispatch(getAllConditionsListSlice(null));
    storeInLocal('srUploadSegment', value);
  };

  const activeTab = superAdminButton.find(
    (button) => button.value === activeButton
  )?.component;

  useEffect(() => {
    if (!activeTab) {
      setActiveButton(superAdminButton[0].value);
    }
  }, [activeTab]);

  return (
    <div className={`page-wrapper`}>
      <OrganizationFilter />
      <div className="lg:flex gap-3 justify-between py-3 items-center ">
        <Segmented
          options={superAdminButton.map((button) => ({
            label: button.label,
            value: button.value,
          }))}
          value={activeButton}
          onChange={(value) => {
            handleSegmentedTabChange(value);
          }}
        />
      </div>
      <div>{activeTab}</div>
    </div>
  );
};

export default ServiceRequestUpload;
